import React, { useContext } from 'react';
import {
  AppContext,
  Logo,
  useActivityTracker,
  CurrencyText
} from '@nile/components';
import { FormattedMessage } from 'react-intl';
import envConfig from '@nile/home/src/Config/env';
import {
  DisplayText,
  TextStyle,
  UnstyledButton
} from '@superops/ui-design-system';
import { NumberChartWrapper } from './styles';
import { Tooltip } from 'react-clone-tippy';
import { NUMBER_CHART } from '../../../constants';

const NumberChart = (props) => {
  const { data, type, tooltipContent = '' } = props;

  const appContext = useContext(AppContext);
  const { companyInfo } = appContext;

  const onBtnCallbackClick = (index) => {
    useActivityTracker({
      event: 'Data Table Preview - from Widget'
    });
    props.btnCallback(index);
  };

  if (!data || !Array.isArray(data)) {
    return (
      <div className="flex actr jctr full-height">
        <div className="flex-center fcol">
          <Logo
            url={`${envConfig.imageRoot}svg/chartEmpty.svg`}
            height="150px"
            width="200px"
          />
          <div className="flex actr jctr mt10">
            <TextStyle variation="subdued">
              <FormattedMessage id="reports.chart.data.empty" />
            </TextStyle>
          </div>
        </div>
      </div>
    );
  }

  const renderDataValue = (item) => {
    if (
      item.hasOwnProperty('metricUnitType') &&
      item.metricUnitType === 'CURRENCY'
    ) {
      return <CurrencyText value={item.value} />;
    }
    return item.value;
  };

  return (
    <NumberChartWrapper className={`flex wrap actr jspeven`}>
      {data?.map((item, i) => (
        <div className="flex-center fcol g20" key={`holder_${i}`}>
          <div className="label">
            <TextStyle>{item.label}</TextStyle>
          </div>
          <Tooltip title={tooltipContent}>
            <div className="value">
              {item.value ? (
                type === NUMBER_CHART.SUB_TYPE.BUTTON ? (
                  <UnstyledButton plain onClick={() => onBtnCallbackClick(i)}>
                    <TextStyle weight="Bold">
                      <span className="value link-text">
                        {renderDataValue(item)}
                      </span>
                    </TextStyle>
                  </UnstyledButton>
                ) : (
                  <TextStyle weight="Bold">{renderDataValue(item)}</TextStyle>
                )
              ) : (
                <TextStyle variation="subdued" weight="Bold">
                  <FormattedMessage id="app.noData.message" />
                </TextStyle>
              )}
            </div>
          </Tooltip>
          {item.hasOwnProperty('metricUnit') && (
            <div className="fx jctr">
              <DisplayText element="h3" weight="medium">
                {item.metricUnit || ''}
              </DisplayText>
            </div>
          )}
        </div>
      ))}
    </NumberChartWrapper>
  );
};

export default NumberChart;
